import CookieConsent from '@/Plugins/cookieconsent-plugin.js';
import ZiggyPlugin from '@/Plugins/ziggy-plugin.js';
import moment from 'moment-timezone';
import PortalVue from 'portal-vue';
import Vue from 'vue';
import VueClipboard from 'vue-clipboard2';
import VueFullscreen from 'vue-fullscreen';
import VueMoment from 'vue-moment';
import VueScrollTo from 'vue-scrollto';
import VueSocialSharing from 'vue-social-sharing';
import Vuex from 'vuex';

Vue.use(VueFullscreen);
Vue.use(VueSocialSharing);
Vue.use(VueClipboard);
Vue.use(VueScrollTo);
Vue.use(ZiggyPlugin);
Vue.use(Vuex);
Vue.use(PortalVue);
Vue.use(VueMoment, { moment });

Vue.use(CookieConsent);
